import { MenuDivider as CorgixMenuDivider } from '@veeva/corgix/menu';
import { menuDividerCSS } from './styles/MenuDivider.styles';

export default function MenuDivider(...props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <CorgixMenuDivider css={menuDividerCSS} {...props} />;
}

// Use an explicit displayName matching the value in Corgix, otherwise, we get a VPM warning that it's not supported.
MenuDivider.displayName = 'MenuDivider';
